'use strict';

exports.__esModule = true;
exports.getUserRole = exports.USER_ROLES = undefined;

var _webUtils = require('@vezeeta/web-utils');

var USER_ROLES = exports.USER_ROLES = {
  OWNER: 'Owner',
  DOCTOR: 'Doctor',
  ASSISTANT: 'Assistant',
  SINGLE_DR_APP: 'SINGLE_DR_APP'
};

var getUserRole = exports.getUserRole = function getUserRole() {
  if (_webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN)) {
    var userToken = (0, _webUtils.decodeJwtToken)(_webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN)).payLoad;
    var userRoles = userToken.role;
    if (userRoles && userRoles.length) {
      // Owner [ENtity Owner]
      // Doctor [Single under entity]
      // Assistant
      // Owner + Doctor [Single Dr APp]

      if (userRoles.includes('Owner') && !userRoles.includes('Doctor')) return USER_ROLES.OWNER;
      if (!userRoles.includes('Owner') && userRoles.includes('Doctor')) return USER_ROLES.DOCTOR;
      if (userRoles.includes('Assistant')) return USER_ROLES.ASSISTANT;
      if (userRoles.includes('Owner') && userRoles.includes('Doctor')) return USER_ROLES.SINGLE_DR_APP;
    }
  }
  return '';
};